import { render, staticRenderFns } from "./InvestList.vue?vue&type=template&id=a3f13f3c&scoped=true"
import script from "./InvestList.vue?vue&type=script&lang=js"
export * from "./InvestList.vue?vue&type=script&lang=js"
import style0 from "./InvestList.vue?vue&type=style&index=0&id=a3f13f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f13f3c",
  null
  
)

export default component.exports